import React from 'react';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';
import { closeJobDescriptionFromExternalWebsite } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const CloseJobDescriptionFromExternalWebsiteForm = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { onResponse, onError, closeCloseJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    closeJobDescriptionFromExternalWebsite({
      onResponse,
      onError,
      body: {
        authenticityToken,
        closeJobDescriptionFromExternalWebsite: jobDescriptionsFromExternalWebsitesState?.closeJobDescriptionFromExternalWebsite,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to close this job description from external website?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeCloseJobDescriptionFromExternalWebsiteModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Yes. Close This Job Description from External Website.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default CloseJobDescriptionFromExternalWebsiteForm;